import React, { useState, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Container, Header, Heading, Content } from "../Summarize/Style";
import { Iframe } from "../Iframe/Style";
import BackIcon from "../../assets/back-icon.svg";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


const Transcriber = () => {
  const { t, i18n } = useTranslation();
  const { isSidebarOpen } = useOutletContext();
  const email = localStorage.getItem("email");
  const [iframeSrc, setIframeSrc] = useState(
    `https://transcriber.aivoria.nl/?email=${email}&lang=${i18n.language}`,
  );

  useEffect(() => {
    setIframeSrc(
      `https://transcriber.aivoria.nl/?email=${email}&lang=${i18n.language}`,
    );
  }, [i18n.language, email]);

  const navigate = useNavigate();

  return (
    <Container isOpen={isSidebarOpen} style={{ marginRight: "1.4rem" }}>
      <Header
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          <img src={BackIcon} alt={t("transcriber.back")} />

          <Heading style={{ marginBottom: 0 }}>
            {t("transcriber.title")}
          </Heading>

          <Tooltip
            title={t("transcriber.tooltip")}
            placement="top"
          >
            <InfoCircleOutlined
              style={{
                fontSize: 14,
                color: "#8c8c8c",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()} // prevent navigation
            />
          </Tooltip>
        </div>

        <p>{t("transcriber.info")}</p>
      </Header>
      <Content style={{ border: "0px" }}>
        <Iframe src={iframeSrc} allow="microphone; clipboard-write" />
      </Content>
    </Container>
  );
};

export default Transcriber;
